import React, { useState } from "react";
import Input from "./Input.js";
import { IoClose } from "react-icons/io5";

function SearchBar({ containerClassName = "", className = "", onChange, initialQuery = "", hide = false, ...rest }) {
  const [text, setText] = useState(initialQuery);

  return (
    <div className="relative">
      <Input
        value={text}
        onChange={(e) => {
          let text = e.target.value;
          setText(text);
          if (onChange) {
            onChange(text);
          }
        }}
        className={`
          ${className} cursor-pointer w-full px-4 py-1 block
               `}
        autoCorrect="none"
        autoCapitalize="none"
        spellCheck="none"
        {...rest}
      />
      <div
        className={`absolute right-0 px-2 top-0 h-full items-center cursor-pointer animate-ease-2 text-gray-600 hover:text-gray-900 active:text-gray-800
               ${text.trim() === "" ? "opacity-0 invisible" : "opacity-100 visible"}
               ${hide ? "hidden" : "flex"}
               `}
        onClick={() => {
          setText("");
          onChange("");
        }}
      >
        <IoClose />
      </div>
    </div>
  );
}

export default SearchBar;
